/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { Col, Container, Row, Breadcrumb, BreadcrumbItem, LinkList, LinkListItem, Spinner, Card, CardBody, CardText, CardTitle, CardReadMore } from 'design-react-kit';
import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import ApiService from "../../../services/api";
import { CategoryClass } from '../../categories/models/category';
import Page404 from '../../pages/page404';
import { WidgetClass } from '../../pages/models/widget';
import WidgetSearch from '../../pages/components/widget_search';
import WidgetDocuments from '../../documents/components/widget_documents';
import WidgetPageRating from 'pa_kit/apps/page_evaluation/components/widget_page_rating';
import WidgetContacts from 'pa_kit/apps/contacts/components/widget_contacts';
import parse from 'html-react-parser';
import { ActaAuthContext } from "pa_kit/auth";
import { LocalSettingsContext } from "services/local_settings";
import { Helmet } from "react-helmet-async";


const PageDocumentsCategory = () => {

    let { categorySlug } = useParams();

    const auth = useContext(ActaAuthContext);
    const settings = useContext(LocalSettingsContext);

    const localSettings = settings.localSettings;
    const organization = auth.organization;

    const documentsParentCategory = localSettings.documents_parent_category_data === null ? '' : localSettings.documents_parent_category_data.title
    const documentsParentCategorySlug = localSettings.documents_parent_category_data === null ? '' : localSettings.documents_parent_category_data.slug

    const [ categoryList, setCategoryList ] = useState();
    const [ category, setCategory ] = useState();

    const [ mainSection, setMainSection ] = useState({});

    const [ widget, setWidget ] = useState();

    const [ isLoading, setIsLoading ] = useState(true);
    const [ pageNotFound, setPageNotFound ] = useState(false);

    const [ breadcrumb, setBreadcrumb ] = useState();
    const [ noSubCatList, setNoSubCatList ] = useState(false);    

    const [ widgetSearch, setWidgetSearch ] = useState();

    const fetchCategory = async() => {
        try {
            const category = await ApiService.getCategory(categorySlug);
            setCategory(new CategoryClass(category));
            setWidget(new WidgetClass({        
                name: "DocumentsCategoryRow",
                class: "documents-category-row",
                category: category.id,
                show_number: 12  
            }));
            setWidgetSearch(new WidgetClass({
                name: "SearchSection",
                class: "search-alldocuments-section",
                type: "search",
                label: "Cerca documenti e dati",
                search_in: "main_sections",
                search_id: 2
            }));
            setIsLoading(false);
        } catch (error) {
            setPageNotFound(true);            
        }       
    }

    useEffect(() => {
        fetchCategory();
    }, [isLoading]);
    

    const fetchCategoryList = async() => {
        const categoryListData = await ApiService.getCategoryList();
        let categoryList;
        if (!category) return;
        categoryList = categoryListData.filter(cat => cat.is_document === true && cat.parent.id === category.id);
        if(categoryList.length === 0) {
            categoryList = categoryListData.filter(cat => cat.is_document === true && cat.parent.id === category.parent.id);
            setNoSubCatList(true);
        }
        // let categoryArray = [];
        categoryList = categoryList.slice().sort((a, b) => a.name.localeCompare(b.name));
        // Promise.all(categoryList.map((category) => ApiService.getLatestDocumentsByCategory(category.id))).then((documents) => {
        //     documents.forEach((document) => {
        //         if(document.length > 0) {
        //             categoryArray.push(document[0].category.id);
        //         }
        //     });
        //     const categoryDocuments = categoryList.filter(cat => categoryArray.includes(cat.id));
        //     setCategoryList(categoryDocuments);
        // });
        setCategoryList(categoryList);
        setIsLoading(false);
    }
    

    useEffect(() => {
        fetchCategoryList();
    }, [isLoading]);

    const fetchBreadcrumb = async() => {
        if(category) {
            let breadcrumb = await category.getBreadcrumb();  
            setBreadcrumb(breadcrumb);
        }
    }
    
    useEffect(() => {
        fetchBreadcrumb();
    }, [category]);


    const fetchMainSections = async() => {
        const mainSectionsData = await ApiService.getMainSections();
        const mainSection = mainSectionsData.filter(main_section => main_section.id === 2); // Documenti e Dati
        setMainSection(mainSection[0]);
    }

    useEffect(() => {
        fetchMainSections();
    }, [category]);
       
    if(pageNotFound) return <Page404 />;
    if(isLoading) return <Container style={{ padding: "50px" }}><Spinner active /></Container>; 
    return <>
        <Helmet>
            <title>{category.name + ' | ' + organization.name}</title>
            <meta name="description" content={category.description.replace(/(<([^>]+)>)/gi, "")} />
        </Helmet>
        <Container fluid className="p-0 news-category-main-wrapper">
            <Container className="pt-5 px-3">
                <Row>
                    <Col>
                        <Breadcrumb>
                        {breadcrumb &&
                            <>
                            <BreadcrumbItem>
                                <a href='/'>Home</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            {documentsParentCategory !== ''
                                && 
                                <BreadcrumbItem>
                                    <a href={'/' + documentsParentCategorySlug + '/'}>{documentsParentCategory}</a>
                                    <span className='separator'>/</span>
                                </BreadcrumbItem>
                            }
                            <BreadcrumbItem>
                                <a href='/documenti-e-dati/'>{mainSection.name}</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            </>
                        }
                            {breadcrumb && breadcrumb.map((crumb, i) =>
                                <React.Fragment key={"key_breadCrumb_" + i}>
                                {(i < breadcrumb.length - 1)
                                    ?   <BreadcrumbItem>
                                            <a href={'/documenti-e-dati/' +  crumb[1] + '/'}>{crumb[0]}</a>
                                            <span className='separator'>/</span>
                                        </BreadcrumbItem>
                                    :   <BreadcrumbItem>
                                            {crumb[0]}                                            
                                        </BreadcrumbItem>                                    
                                }
                                </React.Fragment> 
                            )}
                        </Breadcrumb>
                    </Col>
                </Row>
            </Container>

            <Container className={'page-title document-category-page-title-page'}>
                <Row>
                    <Col lg="7">
                        <h1>{category.name}</h1>
                        <div className="mt-4">{parse(category.description)}</div>
                        <WidgetSearch widget={widgetSearch} />
                    </Col>
                    <Col lg="5">
                    <Container fluid className={'document-page-menu page-menu-content ms-lg-5 ps-lg-5'}>
                        <p className="menu-name mb-2">{noSubCatList ? (category.parent.name || 'Tutti i documenti') : category.name}</p>
                        <LinkList>
                            {categoryList && categoryList.map((category) => 
                                category.alt_link 
                                    ? <LinkListItem key={"key_menuItem_" + category.name} href={category.alt_link}  target="_blank" rel="noreferrer" className="ps-0 menu-item-link">{category.name}</LinkListItem>
                                    : <LinkListItem key={"key_menuItem_" + category.name} href={'/documenti-e-dati/' + category.slug + '/'} className="ps-0 menu-item-link">{category.name}</LinkListItem>                                
                            )}
                        </LinkList>
                    </Container>
                    </Col>
                </Row>
            </Container>
            
            <Container className="mt-5">
                <WidgetDocuments widget={widget} />
            </Container>
            
            {!noSubCatList && 
                <Container className="mt-5">
                    <h2>Tutti i documenti</h2>
                    <Row>
                    {categoryList && categoryList.map((category) =>
                        <Col xs='12' lg='4' className="mt-4" key={"key_cardItem_" + category.id}>                    
                            <Card className="menu-card border border-light shadow-sm">
                                <CardBody>
                                    <CardTitle tag='h3' className='big-heading'>
                                        {category.alt_link 
                                            ? <a href={category.alt_link} target="_blank" rel="noreferrer" className="text-decoration-none me-2" title={category.name}>{category.name}</a>
                                            : <a href={'/documenti-e-dati/' + category.slug + '/'} className="text-decoration-none me-2" title={category.name}>{category.name}</a>
                                        }
                                    </CardTitle>
                                    <CardText>
                                        {parse(category.description.replace(/(<([^>]+)>)/gi, ""))}
                                    </CardText>
                                        {category.alt_link
                                            ? <CardReadMore href={category.alt_link} target="_blank" rel="noreferrer" text='Vai alla pagina' iconName='it-arrow-right' />
                                            : <CardReadMore href={'/documenti-e-dati/' + category.slug + '/'} text='Vai alla pagina' iconName='it-arrow-right' />
                                        }
                                </CardBody>
                            </Card>
                        </Col>
                    )} 
                    </Row>
                </Container>
            }

            <Container fluid className={'rating-wrapper page-rating documents-category-page-rating'}>
                <WidgetPageRating page_title={category.name} />
            </Container> 

            <Container fluid className={'contacts-wrapper documents-category-page-contacts'}>
                <WidgetContacts />
            </Container>
            
        </Container>
        </>;
}

export default PageDocumentsCategory;